export default "__VITE_ASSET__7DCIYrbI__"